import React, { useContext } from 'react';
import { useQuery } from '@apollo/react-hooks';
import EvergreenMessage from './EvergreenMessage';
import { HeaderContext } from '../../../../contexts/HeaderData/HeaderData';
import { HeaderDynamicContext } from '../../../../contexts/HeaderDynamicData/HeaderDynamicData';
import getFromStorage from '../../../../helpers/storage/storage';
import { getFreeShippingAndReturnsLegalCopies } from '../../../../queries';

export const userQualified = (data) => {
  const bagSummary = data ? data.orderSummary : {};
  const loyalty = bagSummary ? bagSummary.loyalty : {
    loyaltyFreeReturnsEligible: false,
    loyaltyFreeShippingEligible: false,
  };
  const freeReturns = loyalty ? loyalty.loyaltyFreeReturnsEligible : false;
  const freeShipping = loyalty ? loyalty.loyaltyFreeShippingEligible : false;
  if (!freeReturns && !freeShipping) {
    return null;
  }
  const base = 'You Qualify for Free';
  if (freeShipping && freeReturns) {
    return `${base} Shipping and Returns`;
  }
  if (freeShipping) {
    return `${base} Shipping`;
  }
  return `${base} Returns`;
};

export const userQualifiedForFreeShipping = (
  userQualification, freeShippingAndReturns) => !!userQualification && freeShippingAndReturns;

export const returnMessageAndLabel = (isChangeCopy, userQualification, data) => {
  if (isChangeCopy) {
    return { message: userQualification, label: 'Details' };
  }

  const headerProperty = data ? data.headerProperty : '';
  return {
    message: headerProperty ? headerProperty.evergreenMessage : '',
    label: headerProperty ? headerProperty.linkText : '',
  };
};

function EvergreenMessageVM(props) {
  const {
    customer,
    orderSummary: orderSummaryData,
    orderSummaryLoading: loading,
  } = useContext(HeaderDynamicContext);
  const { data } = useContext(HeaderContext);
  const loyaltyWarmStateData = getFromStorage('loyaltyWarmStateData', {});
  const isECCHolderAccount = customer.nextCreditCardHolder || false;
  const loyaltyId = loyaltyWarmStateData.loyaltyNumber || '';
  const freeShippingAndReturnsLegalCopiesData = useQuery(getFreeShippingAndReturnsLegalCopies, {
    variables: { loyaltyId },
  });
  const userQualification = userQualified(orderSummaryData);
  const freeShippingAndReturns = window.FLAGS ? window.FLAGS.FreeShippingAndReturns : false;
  const isEccHolderFlag = window.FLAGS ? window.FLAGS.EccHolderFlag : false;
  const changeCopy = userQualifiedForFreeShipping(userQualification, freeShippingAndReturns);

  const isModalEnable = !!loyaltyId;

  const { message, label } = returnMessageAndLabel(changeCopy, userQualification, data);
  const headerProperty = data ? data.headerProperty : '';
  return (
    <EvergreenMessage
      {...props}
      message={loading ? null : message}
      label={label}
      freeShippingAndReturns={freeShippingAndReturns}
      isUserQualified={!!userQualification || isECCHolderAccount}
      isEccHolderFlag={isEccHolderFlag}
      url={headerProperty ? headerProperty.linkHref : ''}
      isModalEnable={isModalEnable}
      freeShippingAndReturnsLegalCopiesData={freeShippingAndReturnsLegalCopiesData}
    />
  );
}

export default EvergreenMessageVM;
